import { StaticQuery, graphql } from "gatsby";
import React from "react";

import {
  Section,
  Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

export const EnvironmentalStewardship = () => (
  <Section>
    <StaticQuery
      query={graphql`
        query EnvironmentStewardshipHeroImageQuery {
          file(relativePath: { eq: "car_charger.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt=""
          css={`
            + picture > img,
            img {
              object-position: 70% 50%;
              @media screen and (min-width: ${getSize("tablet720")}) {
                object-position: 50% 50%;
              }
            }
          `}
          file={file}
        />
      )}
    />
    <Card
      css={`
        @media screen and (min-width: ${getSize("desktop1920")}) {
          width: 552px;
        }
      `}
    >
      <Header2>
        {"Environmental Stewardship"}
        <Underlined />
      </Header2>
      <Paragraph>
        {
          "Smart Homes can be eco-friendly without sacrifice to your quality of living. Homeowners can view available green energy production, dynamically control consumption and reduce their overall carbon footprint."
        }
      </Paragraph>
    </Card>
  </Section>
);
